// extracted by mini-css-extract-plugin
export default {"buttonCarousel":"LoyaltyProgramServiceMyCompany_buttonCarousel__80cr8","item":"LoyaltyProgramServiceMyCompany_item__QdRrL","title":"LoyaltyProgramServiceMyCompany_title__gD3vG"};